import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import ReactMarkdown from "react-markdown";
import { useI18n } from "@/lib/i18n";

interface LegalPageProps {
  contentKey: string;
}

const legalPages = [
  { path: "/terms", labelKey: "index.terms" },
  { path: "/privacy", labelKey: "index.privacy" },
  { path: "/cookies", labelKey: "index.cookies" },
  { path: "/about", labelKey: "sidebar.aboutUs" },
];

export default function LegalPage({ contentKey }: LegalPageProps) {
  const { t } = useI18n();
  const content = t(contentKey);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <header className="flex items-center px-4 py-2 h-12 border-b border-border">
        <Link
          to="/"
          className="p-2 rounded-full hover:bg-accent text-muted-foreground transition-colors"
          aria-label="Back"
        >
          <ArrowLeft className="w-5 h-5" />
        </Link>
      </header>
      <div className="max-w-3xl mx-auto px-4 py-8 flex-1 w-full">
        <div className="prose prose-sm max-w-none prose-headings:text-foreground prose-p:text-foreground prose-li:text-foreground prose-strong:text-foreground text-foreground">
          <ReactMarkdown>{content}</ReactMarkdown>
        </div>
      </div>
      <footer className="border-t border-border py-6 mt-8">
        <div className="max-w-3xl mx-auto px-4 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-muted-foreground">
          <Link to="/" className="hover:text-foreground transition-colors">
            ← {t("sidebar.backToChat") || "Hlavní stránka"}
          </Link>
          <span className="hidden sm:inline text-border">|</span>
          {legalPages.map((page) => (
            <Link
              key={page.path}
              to={page.path}
              className="hover:text-foreground transition-colors"
            >
              {t(page.labelKey) || page.path}
            </Link>
          ))}
        </div>
      </footer>
    </div>
  );
}
